<template>
  <a-modal
      :title="title"
      :width="1160"
      :visible="visible"
      :confirmLoading="loading"
      :maskClosable="false"
      :centered="true"
      :footer="null"
      :destroyOnClose="true"
      @cancel="cancel"
  >
    <a-spin :spinning="loading">
      <s-table
          ref="table"
          rowKey="ai_id"
          :loading="isLoading"
          :columns="columns"
          :data="loadData"
          :pageSize="15"
          :scroll="{y:500}"
      >
        <div slot="price" slot-scope="text, item">
          <span style="color: red">¥</span>{{ text }}
        </div>

        <div slot="number" slot-scope="text, item">
          {{ text }}{{ item.tool_unit }}
        </div>

        <div class="actions" slot="action" slot-scope="text, item">
<!--          <a v-action:edit @click="handleEdit(item)">编辑</a>-->
          <a-popconfirm
              title="确认删除当前记录？"
              ok-text="确定"
              cancel-text="取消"
              @confirm="handleDelete(item)"
          >
            <a href="#">删除</a>
          </a-popconfirm>
        </div>
      </s-table>
    </a-spin>
  </a-modal>
</template>
<script>
import {STable} from "@/components";
import * as Api from "@/api/tool/toolApproveInfo";

export default {
  name: "approveModel",
  components: {
    STable
  },
  data() {
    return {
      title: '领取记录',
      queryParam: {
        tool_id: ''
      },
      visible: false,
      loading: false,
      isLoading: false,
      columns: [
        {
          title: '领取人',
          dataIndex: 'personnel.personnel_name',
          align: 'center',
        },
        {
          title: '车牌号码',
          dataIndex: 'vehicle.vehicle_name',
          align: 'center',
        },
        {
          title: '工具名称',
          dataIndex: 'tool_name',
          align: 'center',
        },
        {
          title: '单价',
          dataIndex: 'price',
          align: 'center',
          scopedSlots: {customRender: 'price'}
        },
        {
          title: '领取数量',
          dataIndex: 'number',
          align: 'center',
          scopedSlots: {customRender: 'number'}
        },
        {
          title: '总计金额',
          dataIndex: 'total_amount',
          align: 'center',
          scopedSlots: {customRender: 'price'}
        },
        {
          title: '领取时间',
          dataIndex: 'create_time',
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'action',
          fixed: 'right',
          scopedSlots: {customRender: 'action'}
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: param => {
        return Api.list({...param, ...this.queryParam})
            .then(response => {
              return response.data.list
            })
      }
    }
  },
  methods: {
    open(tool_id) {
      this.queryParam.tool_id = tool_id
      this.visible = true
    },
    cancel() {
      this.visible = false
    },
    handleDelete(item){
      Api.deleted({apiId: item['ai_id']})
          .then((result) => {
            this.$message.success(result.message, 1.5)
            this.handleRefresh()
          })
          .finally(result => {
          })
    },
    /**
     * 刷新列表
     * @param Boolean bool 强制刷新到第一页
     */
    handleRefresh(bool = false) {
      this.$refs.table.refresh(bool)
    },
  }
}
</script>
<style scoped lang="less">

</style>
